module.exports = __webpack_public_path__ + "static/img/yycj_01.ad1b560.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/yycj_01.png
// module id = bCak
// module chunks = 2